document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-canopy-loyalty]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const launcher = document.getElementById('bon-loyalty-btn');
  if (launcher) {
    event.preventDefault();
    launcher.click();
  }
});
